import { Injectable } from '@angular/core';
import { SessionQuery } from '@app/core/state/session';
import { RightsConst } from '@pezi/entities';

@Injectable()
export class RightUtil {
  constructor(private sessionQuery: SessionQuery) {
  }

  public hasRight(right: RightsConst): boolean {
    const usr = this.sessionQuery.getLoggedInUser();
    if (usr && usr.rights && usr.rights.findIndex(r => r.rightId === right) !== -1) {
      return true;
    } else {
      return false;
    }
  }

  public hasAnyOfGivenRights(rights: RightsConst[]): boolean {
    const usr = this.sessionQuery.getLoggedInUser();
    return usr ? usr.rights.some(r => rights.indexOf(r.rightId) >= 0) : false;
  }

  public hasAllOfGivenRights(rights: RightsConst[]): boolean {
    const usr = this.sessionQuery.getLoggedInUser();
    return usr ? rights.every(right =>
      usr.rights.findIndex(userRight => userRight.rightId === right) !== -1
    ) : false;
  }
}
